<!--
 * @Author: Victor victorqwer1234567890@gmail.com
 * @Date: 2023-12-28 17:02:33
 * @LastEditors: Merlin
 * @LastEditTime: 2024-11-04 17:55:17
 * @Description: 
-->
<template>
    <!-- ↓ ⌚ 时间信息列，点击之后将弹出窗口 -->
    <CasinoHistoryBodyCell
        class="cursor-pointer"
        @click="onOpenModalClick"
    >
        <!-- {{ moment(history.timestamp).format('hh:mm:ss A') }} -->
        <p class="flex flex-col">
            <span class="text-[12px] text-white">
                {{ moment(history.timestamp).format('YYYY/MM/DD') }}
            </span>
            <span class="text-[11px] text-[#93acd3]">
                {{ localeLang === 'cn' ? moment(history.timestamp).format('HH:mm:ss') : moment(history.timestamp).format('hh:mm:ss A') }}
            </span>
        </p>
    </CasinoHistoryBodyCell>
    <!-- ↓ 💲押注金额列 -->
    <CasinoHistoryBodyCell
        class="flex-[0.9]"
        @click="showPharaoBonusGameAmount ? void 0 : onOpenModalClick()" 
    >
        <CasinoHistoryCoinContent
            :history="history"
            :currency-name="history.currency"
            :amount="Number(history.amount)"
            :showPharaoBonusGameAmount="showPharaoBonusGameAmount"
        />
    </CasinoHistoryBodyCell>
    <!-- ↓ ✖️ 倍数信息列 --> 
    <CasinoHistoryBodyCell
        class=" inline-flex flex-[0_1_78px]"
        :class="[history.winAmount > 0 && 'text-[#1BB83D]']"
        @click="onOpenModalClick" 
    >
        <span class="bg-[#2a3546] ellipsis rounded-3xl px-2 text-[13px]">
            {{ `x${getFixed(history.multi)}` }}
        </span>
    </CasinoHistoryBodyCell>
    <!-- ↓ 💲提现金额，是最后一列 --> 
    <CasinoHistoryBodyCell
        class="justify-between flex-[1] !pr-0"
        @click="onOpenModalClick" 
    >
        <CasinoHistoryCoinContent
            :history="history"
            :currency-name="history.currency"
            :amount="Number(getFixed(Number(history.winAmount)))"
            :validate-number-calss="Number(history.winAmount) > 0 ? 'text-[#1BB83D]' : '!text-[#55657e]'"
        />
    </CasinoHistoryBodyCell>
</template>


<script setup lang="ts">
import useTranslation from '~/i18n/useTransLation';
import type { BetHistoryType } from '~/socket/gamehistory/dto/gameHistory.dto';
import moment from 'moment';
import useGlobalStore from '@/stores/global';
import {getGameApi} from '@/common/js/gameAbout'; 

const globalStore = useGlobalStore();
const router = useRouter();
const route = useRoute();

const props = defineProps({
    isMobileMode: Boolean, // 声明出来，否则控制台一直打印 warn 信息 
    history: {
        type: Object as PropType<BetHistoryType>,
        default: () => ({}),
    },
    userModalControl: Function,
    seeRoundDetail: Function,
});
const t = useTranslation();

// ↓ pharaoh 游戏专用，表示是用户是否买了特奖 
const showPharaoBonusGameAmount = computed(()=>{
    const {history} = props;
    const bResult = (
        history['bonusGameAmount'] > 0 
        && history.game?.id === 12 // pharaoh
    ); 
    return bResult;
});

const oTheI18n = useI18n();
const localeLang = computed(() => {
    return oTheI18n?.locale?.value;
});

const onOpenModalClick = () => {
    // gameInformationModal.value = !gameInformationModal.value;
    const gameName = props.history.game.name || getGameApi();
    const data = `${gameName}:${props.history._id}`;
    router.push({
        replace: true,
        path: route.path,
        query: {
            modal: 'BetDetails',
            data,
        },
    });
};
</script>
